const KEY = 'ss_cms_token';

const Authorization = {
    /**
     * Set the access token of the user logging in
     * @param {string} token The access token of the user
     * @param {boolean} local Should it be stored in localStorage
     */
    setToken(token, local = false) {
        if (!local) {
            sessionStorage.setItem(KEY, token);
        }
        else {
            localStorage.setItem(KEY, token);
        }
    },
    /**
     * Retrieve the token of the logged in user
     */
    getToken() {
        return localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
    },
    /**
     * Clear the token of the logged in user
     */
    clearToken() {
        console.log('clearing');
        localStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY);
    }
}

export default Authorization;